import asConfig from './AS/Config';

export default {
  ...asConfig,
};
